// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___gfW7","text":"styles_text__UEvmt","icon_wrapper":"styles_icon_wrapper__AAcAO","heading":"styles_heading__pFLXi"};